import {
  accordeon,
} from './components/index';

const RcPostContent = {
  init() {
    accordeon();
  }
};

export default RcPostContent;

RcPostContent.init();
